import {
  getCss,
  buildResponsiveStyles,
  buildResponsiveTextStyles,
  mergeDeep,
  color as colorUtils,
} from '../../utils';
import {
  TTextTag,
  TextAlignType,
  TTextAlign,
  TTextVariant,
  TextColorType,
  TTextColor,
  TTextWeight,
} from './text-utils';

export const createStyles = (
  tag: TTextTag,
  variant: TTextVariant,
  color: TTextColor,
  align: TTextAlign,
  weight: TTextWeight
): string => {
  const styles = getCss({
    '@global': {
      ':host': {
        // if default tag is displayed as block use display: block
        display: 'block',
      },
      [tag as string]: {
        display: 'inline-block',
        fontFamily: 'Bosch Sans',
        textDecoration: 'inherit',
        margin: '0',
        ...mergeDeep(
          buildResponsiveTextStyles(variant as string),
          buildResponsiveStyles(color, (colorResponsive: TextColorType) => ({
            color: colorResponsive === 'inherit' ? 'inherit' : colorUtils[colorResponsive],
          })),
          buildResponsiveStyles(align, (alignResponsive: TextAlignType) => ({
            textAlign: alignResponsive,
          })),
          weight
            ? buildResponsiveStyles(weight, (weightResponsive: TTextWeight) => ({
                fontWeight: weightResponsive,
              }))
            : {}
        ),
      },
    },
  });

  return styles;
};
